import { useState } from 'react';

import { cn } from '@/lib/utils';
import { StarIcon } from '../../../assets/Star';

interface StarRatingInputProps {
  value: number;
  onChange: (rating: number) => void;
  size?: number;
  className?: string;
  readOnly?: boolean;
}

export const StarRatingInput: React.FC<StarRatingInputProps> = ({
  value = 0,
  onChange,
  className,
  readOnly = false,
}) => {
  const [hoverRating, setHoverRating] = useState(0);

  const handleMouseOver = (index: number) => {
    if (!readOnly) {
      setHoverRating(index);
    }
  };

  const handleMouseLeave = () => {
    if (!readOnly) {
      setHoverRating(0);
    }
  };

  const handleClick = (index: number) => {
    if (!readOnly) {
      onChange(index);
    }
  };

  return (
    <div className={cn('flex space-x-3', readOnly ? 'cursor-default' : 'cursor-pointer', className)}>
      {[1, 2, 3, 4, 5].map(index => {
        const fillValue = hoverRating > 0 ? hoverRating : value;
        const isFilled = index <= fillValue;

        return (
          <div
            key={index}
            onClick={() => handleClick(index)}
            onMouseOver={() => handleMouseOver(index)}
            onMouseLeave={handleMouseLeave}
          >
            <StarIcon
              className={cn(
                'transition-colors duration-150 size-[40px]',
                isFilled ? 'text-yellow-400 fill-yellow-400' : 'text-gray-200'
              )}
            />
          </div>
        );
      })}
    </div>
  );
};
